import LoginPage from "./pages/login/LoginPage";
import RegisterPage from "./pages/register/RegisterPage";
import SearchPage from "./pages/search/SearchPage";
import MemorialPage from "./pages/memorial/MemorialPage";
import RegisterBuriedPage from "./pages/register-buried/RegisterBuriedPage";
import RegisterBurialPage from "./pages/register-burial/RegisterBurialPage";
import UpdateBurialPage from "./pages/register-burial/UpdateBurialPage";
import RegisterJazigoPage from "./pages/register-jazigo/RegisterJazigoPage";
import QrCodeJazigo from "./pages/qrCodeJazigo/qrCodeJazigo";
import ChangePassword from "./pages/change-password/ChangePassword";

/**
 * Content — roteador de páginas; decide qual componente renderizar com base em `page`.
 * @param {string}   page              - identificador da página ativa
 * @param {function} navigate          - altera a página ativa
 * @param {object}   user              - dados do usuário logado (null quando deslogado)
 * @param {function} onLogin           - callback chamado após autenticação bem-sucedida
 * @param {function} onLogout          - callback chamado ao clicar em Sair
 * @param {object}   selectedFalecido  - falecido selecionado na busca, passado para MemorialPage
 * @param {function} onSelectFalecido  - atualiza o falecido selecionado
 */
function Content({ page, navigate, user, onLogin, onLogout, selectedFalecido, onSelectFalecido, onFalecidoUpdated, falecidos }) {
  switch (page) {
    case "login":
      return <LoginPage navigate={navigate} onLogin={onLogin} />;
    case "register":
      return <RegisterPage navigate={navigate} user={user} onLogout={onLogout} />;
    case "search":
      return <SearchPage navigate={navigate} user={user} onLogout={onLogout} onSelectFalecido={onSelectFalecido} selectedFalecido={selectedFalecido} onFalecidoUpdated={onFalecidoUpdated} />;
    case "memorial":
      return <MemorialPage navigate={navigate} user={user} onLogout={onLogout} falecido={selectedFalecido} onFalecidoUpdated={onFalecidoUpdated} />;
    case "register-buried":
      return <RegisterBuriedPage navigate={navigate} user={user} onLogout={onLogout} selectedFalecido={selectedFalecido}/>;
    case "register-burial":
      return <RegisterBurialPage navigate={navigate} user={user} onLogout={onLogout} />;
    case "update-burial":
      return <UpdateBurialPage navigate={navigate} user={user} onLogout={onLogout} selectedFalecido={selectedFalecido}/>;
    case "register-jazigo":
      return <RegisterJazigoPage navigate={navigate} user={user} onLogout={onLogout} selectedFalecido={selectedFalecido}/>;
    case "qrCodeJazigo":
      return <QrCodeJazigo navigate={navigate} user={user} onLogout={onLogout} falecidos = {falecidos}/>;
    case "change-password":
      return <ChangePassword navigate={navigate} user={user} onLogout={onLogout} />;
    default:
      return <SearchPage navigate={navigate} user={user} onLogout={onLogout} onSelectFalecido={onSelectFalecido} selectedFalecido={selectedFalecido} />;
  }
}

export default Content;
